import { AxiosResponse } from 'axios';
import { Action } from 'redux';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { ConfigBase } from '../../types/config';
import { EventDTO } from '../../types/dto/EventDTO';
import { FollowSignupResponseDTO } from '../../types/dto/FollowSignupResponseDTO';
import ApiHelper from '../ApiHelper';
import { AuthState } from '../auth/Types';
import * as Actions from './Actions';
import { EventsState } from './Types';

type RootSubState = {
    authState: AuthState,
    eventsState: EventsState,
};

type EventsThunkAction<R> = ThunkAction<R, RootSubState, undefined, Action>;
type EventsThunkDispatch = ThunkDispatch<RootSubState, undefined, Action>;

export type ServiceActions = {
    getEvents: () => Promise<EventDTO[]>,
    followSignup: (data: EventDTO) => Promise<FollowSignupResponseDTO>,
};

export const createServiceActions = (config: ConfigBase) => {
    const apiHelper = ApiHelper(config);

    const getEvents = (): EventsThunkAction<Promise<EventDTO[]>> => {
        return async (dispatch) => {
            try {
                dispatch(Actions.getEventsRequest());
                const axiosResponse: AxiosResponse = await dispatch(apiHelper.get(`/api/${config.ResourceCode}/events/get/`, null));
                const response = axiosResponse.data as EventDTO[];
                dispatch(Actions.getEventsSuccess(response));
                return response;
            } catch (error) {
                dispatch(Actions.getEventsFailure());
                throw error;
            }
        };
    };

    const followSignup = (data: EventDTO): EventsThunkAction<Promise<FollowSignupResponseDTO>> => {
        return async (dispatch) => {
            try {
                dispatch(Actions.followSignupRequest());
                const axiosResponse: AxiosResponse = await dispatch(apiHelper.post(`/api/${config.ResourceCode}/events/followsignup`, data));
                const response = axiosResponse.data as FollowSignupResponseDTO;
                dispatch(Actions.followSignupSuccess());
                return response;
            } catch (error) {
                dispatch(Actions.followSignupFailure());
                throw error;
            }
        };
    };

    return {
        getEvents,
        followSignup,
    };
};

export const bindServiceActionCreators = (config: ConfigBase, dispatch: EventsThunkDispatch): ServiceActions => {
    const services = createServiceActions(config);
    return {
        getEvents: () => dispatch(services.getEvents()),
        followSignup: (data: EventDTO) => dispatch(services.followSignup(data)),
    };
};
